<template>
<span>
  <span v-if="isComplex">
    The raw scraped payload will be a <span class="has-text-warning">{{ rawType }}</span> representation of an <span class="has-text-warning">{{ dataType }}</span>
  </span>
</span>  
</template>
<script>
import { first, last } from 'lodash'
export default {
  
  props: {
    type: String
  },

  computed: {
    isComplex() {
      return this.type.indexOf('|') > -1
    },
    parts() {
      return this.type.split('|')
    },
    rawType() {
      return first(this.parts)
    },
    dataType() {
      return last(this.parts)
    }
  }

}
</script>